module.exports = __webpack_public_path__ + "img/contact.79b04448.jpg";